import { AccordionDetails as MuiAccordionDetails, styled } from '@mui/material';

export const AccordionDetails = styled(MuiAccordionDetails)(() => ({
    borderTop: '1px solid rgba(0, 0, 0, .125)',
    padding: 0,
}));
